var lib_core = require("lib-core");

var WindowOpenerStateMachine = function (root, button_id, url) {
    var self = this;

    this.root = root;
    this.button_id = button_id;
    this.url = url;

    lib_core.StateMachine.call(self);

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UI_TRAY_BUTTON && cEvent.data('button_id') == self.button_id;
        },
        function(cEvent){
            var win = window.open(self.url, '_blank');
            if(win)
                win.focus();
            else
                logError("WindowOpener", new Error("Could not open window"), logError.criticality.MAJOR);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.OPEN_URL_IN_NEW_WINDOW;
        },
        function(cEvent){
            var url = cEvent.data('url');
            var win = window.open(url, '_blank');
            if(win)
                win.focus();
            else
                logError("WindowOpener", new Error("Could not open window"), logError.criticality.MAJOR);
        }
    );
};

lib_core.inherit(WindowOpenerStateMachine, lib_core.StateMachine);

module.exports = WindowOpenerStateMachine;
